import "./Career.module.css";
import Header from "@/reusable_sections/Header";
import JobOpening from "./sections/JobOpening";
import Footer from "@/reusable_sections/Footer";
export default function CareerPage() {
  return <div>
      <Header />
      <JobOpening />
      <Footer />
    </div>;
}